/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_When_HintInputs */

const th_meeting_when_hint = /** @type {(inputs: Meeting_When_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เว้นว่างไว้หากต้องการคุยตอนนี้`)
};

const en_meeting_when_hint = /** @type {(inputs: Meeting_When_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leave it empty to meet now.`)
};

const ja_meeting_when_hint = /** @type {(inputs: Meeting_When_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空欄のままにすると今すぐになります。`)
};

const zh_meeting_when_hint = /** @type {(inputs: Meeting_When_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`留空表示现在就见。`)
};

const es_meeting_when_hint = /** @type {(inputs: Meeting_When_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déjalo vacío para reunirte ahora.`)
};

const pt_meeting_when_hint = /** @type {(inputs: Meeting_When_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deixe vazio para conversar agora.`)
};

const id_meeting_when_hint = /** @type {(inputs: Meeting_When_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kosongkan untuk bertemu sekarang.`)
};

const fr_meeting_when_hint = /** @type {(inputs: Meeting_When_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laissez vide pour se voir maintenant.`)
};

const tl_meeting_when_hint = /** @type {(inputs: Meeting_When_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iwanang blangko para magkita ngayon.`)
};

const vi_meeting_when_hint = /** @type {(inputs: Meeting_When_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Để trống để gặp ngay.`)
};

const ko_meeting_when_hint = /** @type {(inputs: Meeting_When_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`지금 만나려면 비워 두세요.`)
};

const de_meeting_when_hint = /** @type {(inputs: Meeting_When_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leer lassen, um sich jetzt zu treffen.`)
};

const ru_meeting_when_hint = /** @type {(inputs: Meeting_When_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оставьте пустым, чтобы встретиться сейчас.`)
};

const tr_meeting_when_hint = /** @type {(inputs: Meeting_When_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şimdi görüşmek için boş bırakın.`)
};

const it_meeting_when_hint = /** @type {(inputs: Meeting_When_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lascia vuoto per incontrarvi subito.`)
};

const pl_meeting_when_hint = /** @type {(inputs: Meeting_When_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zostaw puste, aby spotkać się teraz.`)
};

const uk_meeting_when_hint = /** @type {(inputs: Meeting_When_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Залиште порожнім, щоб зустрітися зараз.`)
};

const hi_meeting_when_hint = /** @type {(inputs: Meeting_When_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अभी मिलने के लिए खाली छोड़ें।`)
};

const ar_meeting_when_hint = /** @type {(inputs: Meeting_When_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اتركه فارغًا للقاء الآن.`)
};

const ms_meeting_when_hint = /** @type {(inputs: Meeting_When_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biarkan kosong untuk berjumpa sekarang.`)
};

const bn_meeting_when_hint = /** @type {(inputs: Meeting_When_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এখনই দেখা করতে ফাঁকা রাখুন।`)
};

const zh_tw2_meeting_when_hint = /** @type {(inputs: Meeting_When_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`留空表示現在就見面。`)
};

const zh_hk2_meeting_when_hint = /** @type {(inputs: Meeting_When_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`留空表示現在就見面。`)
};

const ur_meeting_when_hint = /** @type {(inputs: Meeting_When_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابھی ملنے کے لیے خالی چھوڑ دیں۔`)
};

const fa_meeting_when_hint = /** @type {(inputs: Meeting_When_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`برای دیدار همین حالا خالی بگذارید.`)
};

const sw_meeting_when_hint = /** @type {(inputs: Meeting_When_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acha wazi ili kukutana sasa hivi.`)
};

const nl_meeting_when_hint = /** @type {(inputs: Meeting_When_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laat leeg om nu meteen af te spreken.`)
};

/**
* | output |
* | --- |
* | "Leave it empty to meet now." |
*
* @param {Meeting_When_HintInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const meeting_when_hint = /** @type {((inputs?: Meeting_When_HintInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_When_HintInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_meeting_when_hint(inputs)
	if (locale === "ja") return ja_meeting_when_hint(inputs)
	if (locale === "zh") return zh_meeting_when_hint(inputs)
	if (locale === "es") return es_meeting_when_hint(inputs)
	if (locale === "pt") return pt_meeting_when_hint(inputs)
	if (locale === "id") return id_meeting_when_hint(inputs)
	if (locale === "fr") return fr_meeting_when_hint(inputs)
	if (locale === "tl") return tl_meeting_when_hint(inputs)
	if (locale === "vi") return vi_meeting_when_hint(inputs)
	if (locale === "ko") return ko_meeting_when_hint(inputs)
	if (locale === "de") return de_meeting_when_hint(inputs)
	if (locale === "ru") return ru_meeting_when_hint(inputs)
	if (locale === "tr") return tr_meeting_when_hint(inputs)
	if (locale === "it") return it_meeting_when_hint(inputs)
	if (locale === "pl") return pl_meeting_when_hint(inputs)
	if (locale === "uk") return uk_meeting_when_hint(inputs)
	if (locale === "hi") return hi_meeting_when_hint(inputs)
	if (locale === "ar") return ar_meeting_when_hint(inputs)
	if (locale === "ms") return ms_meeting_when_hint(inputs)
	if (locale === "bn") return bn_meeting_when_hint(inputs)
	if (locale === "zh-TW") return zh_tw2_meeting_when_hint(inputs)
	if (locale === "zh-HK") return zh_hk2_meeting_when_hint(inputs)
	if (locale === "ur") return ur_meeting_when_hint(inputs)
	if (locale === "fa") return fa_meeting_when_hint(inputs)
	if (locale === "sw") return sw_meeting_when_hint(inputs)
	if (locale === "nl") return nl_meeting_when_hint(inputs)
	return en_meeting_when_hint(inputs)
});